import React, { useState } from 'react';
import {
  Container,
  Navbar,
  NavbarBrand,
  Nav,
  NavItem,
  Button,
} from 'reactstrap';
import Modal from '../Common/Modal/Modal';
import CreateExtraCalls from './CreateExtraCalls';
import EditNewCalls from './EditNewCalls';

import { useTranslation } from 'react-i18next';

const BatchCallBar = ({ calls, selectedCallIds, users }) => {
  const [createExtraCallsModal, setCreateExtraCallsModal] = useState(false);
  const [editNewCallsModal, setEditNewCallsModal] = useState(false);

  calls = calls.filter(({ id }) => selectedCallIds.includes(id));
  const { t } = useTranslation();

  return (
    <>
      <div
        className={`fixed-bottom ${
          selectedCallIds.length ? 'visible' : 'invisible'
        }`}
      >
        <Navbar style={{ backgroundColor: '#2a3042' }} dark expand="md">
          <Container style={{ justifyContent: 'flex-start' }}>
            <NavbarBrand>{t('Manage')}:</NavbarBrand>
            <Nav pills>
              <NavItem style={{ marginRight: '15px' }}>
                <Button
                  color="warning"
                  outline
                  className="waves-effect waves-light"
                  onClick={() => setCreateExtraCallsModal(true)}
                >
                  <i className="bx bx-phone-call font-size-20 align-middle mr-2"></i>
                  {t('Create Extra Calls')}
                </Button>
              </NavItem>
              <NavItem>
                <Button
                  color="success"
                  outline
                  className="waves-effect waves-light"
                  onClick={() => setEditNewCallsModal(true)}
                >
                  <i className="bx bx-edit font-size-20 align-middle mr-2"></i>
                  {t('Edit New Calls')}
                </Button>
              </NavItem>
            </Nav>
          </Container>
        </Navbar>
      </div>
      <Modal
        size="xl"
        title="Create Extra Calls"
        isOpen={createExtraCallsModal}
        toggle={() => setCreateExtraCallsModal(!createExtraCallsModal)}
        showClose
        scrollable={false}
      >
        <CreateExtraCalls prevCalls={calls} users={users} />
      </Modal>
      <Modal
        size="xl"
        title="Edit New Calls"
        isOpen={editNewCallsModal}
        toggle={() => setEditNewCallsModal(!editNewCallsModal)}
        showClose
        scrollable={false}
      >
        <EditNewCalls prevCalls={calls} users={users} />
      </Modal>
    </>
  );
};

export default BatchCallBar;
